module.exports = __webpack_public_path__ + "img/_DSC8024-min.b4e6003a.jpg";